__turbopack_export_value__({
  "wrapper": "Schedules-module-scss-module__vQmUKa__wrapper",
});
